import { fontTypesSelector } from 'apps/studio/store/selectors/types'
import { useSelector } from 'react-redux'
import { styleDefaults } from 'apps/studio/lib/utils/styles'

const loadedFonts = new Set()

const getUniqueFontName = ({ fontName, fontStyle, fontWeight }) =>
  `${fontName}-${fontStyle}-${fontWeight}`

const createAndLoadFontFace = async ({
  fileName: fontName,
  location: fontUrl,
  fontStyle,
  fontWeight
}) => {
  const uniqueFontName = getUniqueFontName({
    fontName,
    fontStyle,
    fontWeight
  })

  // Ensure fonts are only loaded once
  if (loadedFonts.has(uniqueFontName)) {
    return
  }

  const fontFace = new FontFace(fontName, `url(${fontUrl})`, {
    style: fontStyle,
    weight: fontWeight,
  })

  fontFace.load().then(font => {
    document.fonts.add(font)
    loadedFonts.add(uniqueFontName)
  })
}

const findFontUrl = (fontTypes, fontName, fontStyle, fontWeight) => {
  const foundFont = fontTypes.find(
    font =>
      font.fileName === fontName &&
      font.fontStyle === fontStyle &&
      font.fontWeight === fontWeight
  )
  
  return foundFont
    ? foundFont.location
    : fontTypes.find(font => font.fileName === styleDefaults.fontFamily)?.location
}

export const loadFont = ({ fontFamily, fontStyle, fontWeight }) => {
  const fontTypes = useSelector(fontTypesSelector)
  const fontUrl = findFontUrl(fontTypes, fontFamily, fontStyle, fontWeight)

  if (fontUrl) {
    createAndLoadFontFace({
      fileName: fontFamily,
      fontUrl,
      fontStyle,
      fontWeight
    })
  }
}

export const loadRegularFonts = state => {
  const { types: { fontTypes } } = state
  fontTypes.forEach(font => {
    const { fontStyle, fontWeight } = font

    if (fontStyle === 'normal' && fontWeight === 400 && location) {
      createAndLoadFontFace({
        ...font,
        fontStyle: 'normal',
        fontWeight: 400
      })
    }
  })
}

export const loadAllFonts = state => {
  const { types: { fontTypes } } = state
  fontTypes.forEach(createAndLoadFontFace)
}